import React from "react";
import MuiTab from "@mui/material/Tab";

import { TabProps } from "./Tab.types";
import makeStyles from "@mui/styles/makeStyles";

const useTabStyles = makeStyles((theme) => ({
  root: {
    minWidth: "initial",
    maxHeight: 20,
    minHeight: "initial",
    lineHeight: "16px",
    marginLeft: 16,
    padding: 0,
    textTransform: "initial",
    cursor: "pointer",
    fontSize: 16,
    // grey[700] is the "correct" per-spec value, but pre-migration a stray
    // CSS override made unselected tabs render lighter; restore that look
    // rather than the newly-unmasked darker grey[700]. No existing grey
    // step lands here (600 too dark, 500 too light) — sits between them.
    color: "#B0B3BB !important",
    "&:first-child": {
      marginLeft: 0,
    },
    fontWeight: 400,
    [theme.breakpoints.up("md")]: {
      maxHeight: 14,
      fontSize: 14,
      lineHeight: "14px",
    },
  },
  selected: {
    color: `${theme.palette.grey[900]} !important`,
    fontWeight: 600,
    [theme.breakpoints.up("md")]: {
      fontWeight: 700,
    },
  },
}));
function Tab(props: TabProps) {
  const tabClasses = useTabStyles();

  return (
    <MuiTab {...props} classes={tabClasses} disableRipple disableFocusRipple />
  );
}

export default Tab;
